/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const previous = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M11.6 7l-1.1-1L5 12l5.5 6 1.1-1L7 12l4.6-5zm6 0l-1.1-1-5.5 6 5.5 6 1.1-1-4.6-5 4.6-5z" />
	</SVG>
);

export default previous;
